module.exports = __webpack_public_path__ + "img/waist.9761517c.png";